import documentElement from './document';

var offsetParent = function (element) {
    var offsetParent = element.offsetParent;

    while (offsetParent && offsetParent.style.position === "static") {
        offsetParent = offsetParent.offsetParent;
    }

    return offsetParent || documentElement(element);
};

export default offsetParent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-popup-common/dist/es/offset-parent.js
// module id = 29
// module chunks = 0